import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { userKey } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useChangeUserMailingList = (id) => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/user-change-mailing-list/`, { ...attributes }, params),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [userKey, id] });
        }
    });
};
export default useChangeUserMailingList;
